export default class PostComponentType {}

PostComponentType.PostNeighborhood = 'neighbourhood.neighbourhood';
PostComponentType.PostNeighbourhoodActivities = 'neighbourhood.activities';
PostComponentType.PostCommittee = 'post.committee';
PostComponentType.PostNavHeader = 'post.nav-header';
PostComponentType.PostContent = 'post.content';
PostComponentType.PostDynamicContent = 'post.dynamic-content';
PostComponentType.PostEducation = 'post.education';
PostComponentType.PostEvent = 'post.event';
PostComponentType.PostFaq = 'post.faq';
PostComponentType.PostMoreInformation = 'post.more-information';
PostComponentType.PostPetServiceAmenity = 'post.pet-service-amenity';
PostComponentType.PostPhoto = 'post.photo';
PostComponentType.PostReference = 'post.reference';
PostComponentType.PostSection = 'post.section';
PostComponentType.PostShoutout = 'post.shoutout';
PostComponentType.PostTable = 'post.table';
PostComponentType.PostVetPartner = 'post.vet-partner';
PostComponentType.PostVetSpotlight = 'post.vet-spotlight';
PostComponentType.PostVideo = 'post.video';
PostComponentType.PostWellness = 'post.wellness';
